export const types = {
    report: 1,
    document: 2,
    log: 3,
    other: 4,
};
